import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ButtonEditar, ButtonPopup } from "@/components/ui";

const SelectorLanding = () => {
  const navigate = useNavigate();

  const { profesionalId, profesionId, perfilId } = useParams<{
    profesionalId: string;
    profesionId: string;
    perfilId: string;
  }>();

 const location = useLocation();

const [showLandingPrincipal, setShowLandingPrincipal] = useState(
  location.state?.showLandingPrincipal ?? false
);

  return (
    <div
      className="
        w-screen
        min-h-screen
        flex
        items-center
        justify-center
        bg-cover
        bg-center
        bg-no-repeat
        px-4
        py-10
      "
      style={{
        backgroundImage:
          "linear-gradient(rgba(0,0,0,.65), rgba(0,0,0,.65)), url('/img/body/fondoEditarLanding.jpeg')",
      }}
    >
      {!showLandingPrincipal ? (
        <div
          className="
          relative
          w-full
          max-w-md
          rounded-[20px]
      
          bg-white/10
          backdrop-blur-2xl
          backdrop-saturate-100
      
          border border-cyan-300/50
      
          shadow-2xl
          shadow-cyan-300/40
      
          before:absolute
          before:inset-0
          before:rounded-[20px]
          before:bg-gradient-to-br
          before:from-white/3
          before:to-transparent
          before:pointer-events-none
      
          overflow-hidden
          p-7
          space-y-4
        "
        >
          <h2 className="text-2xl font-bold text-white text-center">
            Selecciona una sección
          </h2>

          <ButtonEditar
            type="button"
            onClick={() => setShowLandingPrincipal(true)}
          >
            Landing Principal
          </ButtonEditar>

          <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/fondoWeb`,
              )
            }
          >
            Editar fondo web
          </ButtonEditar>

          <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/quienes-somos`,
              )
            }
          >
            Quiénes Somos
          </ButtonEditar>

          <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/ofertas`,
              )
            }
          >
            Ofertas
          </ButtonEditar>

          <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/empleo`,
              )
            }
          >
            Empleo
          </ButtonEditar>

       {/*    <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/contacto`,
              )
            }
          >
            Contacto
          </ButtonEditar> */}

         <ButtonPopup type="button" onClick={() => navigate(`/editProfesional/${profesionalId}/${profesionId}/${perfilId}`, ) } >
            ⬅ Atrás
         </ButtonPopup>
          
        
        </div>
      ) : (
        <div
          className="
         relative
         w-full
         max-w-md
         rounded-[30px]
         border
         border-cyan-300
         bg-white/5
         backdrop-blur-3xl
         p-7
         space-y-4
         shadow-[0_0_60px_rgba(34,211,238,.18)]
       "
        >
          <h2 className="text-2xl font-bold text-white text-center">
            Editar Landing Principal
          </h2>

          <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/editaHero`,
              )
            }
            className="w-full bg-zinc-800 text-white rounded-lg p-3"
          >
            Editar Hero
          </ButtonEditar>

          <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/editaServices`,
              )
            }
            className="w-full bg-zinc-800 text-white rounded-lg p-3"
          >
            Editar Servicios
          </ButtonEditar>

          <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/editaContacto`,
              )
            }
            className="w-full bg-zinc-800 text-white rounded-lg p-3"
          >
            Editar Contacto
          </ButtonEditar>

        {/*   <ButtonEditar
            type="button"
            onClick={() =>
              navigate(
                `/editar-landing/${profesionalId}/${profesionId}/${perfilId}/editaFooter`,
              )
            }
            className="w-full bg-zinc-800 text-white rounded-lg p-3"
          >
            Editar Footer
          </ButtonEditar> */}

          <ButtonPopup
            type="button"
            onClick={() => setShowLandingPrincipal(false)}
            className="w-full text-red-500"
          >
            ⬅ Atrás
          </ButtonPopup>
        </div>
      )}
    </div>
  );
};

export default SelectorLanding;
